import React from 'react';
import { Container } from 'react-bootstrap';

const Blank = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Blank;
